import ActionButton from 'components/ActionButton';
import React, { useState } from 'react';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { Error } from 'components/message/Error';
import { createAccount } from 'services/api/accounts';

const validationSchema = yup.object().shape({
  name: yup.string().required(),
});

type FormData = {
  name: string;
  bankAccountNo: string;
  bankRoute: string;
  address: string;
  phone: string;
};

const CreateAccount = props => {
  const { register, handleSubmit, errors } = useForm<FormData>({ resolver: yupResolver(validationSchema) });

  const [loading, setLoading] = useState<boolean>(false);

  const createAccountFn = handleSubmit(async ({
    address, bankAccountNo, bankRoute, name, phone,
  }) => {
    setLoading(true);
    const accountDetails = {
      name,
      phone,
      bankAccountNo,
      bankRoute,
      address,
    };

    try {
      const res = await createAccount(accountDetails);
      showSuccess('Account added successfully.');
      props.history.replace(`/accounts/${res.id}`);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  });

  return (
    <div className={styles['main-container']}>
      <div className={styles['header']}>
        <div className={styles['heading']}>Create a New Account</div>
      </div>
      <div className={styles['account-details']}>
        <div className={styles['name']}>
          <div className={styles['label']}>Name</div>
          <input
            name={'name'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
          {errors.name && <Error message={errors.name.message} />}
        </div>
        <div className={styles['phone']}>
          <div className={styles['label']}>Phone</div>
          <input
            name={'phone'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
        </div>
        <div className={styles['bank-account-number']}>
          <div className={styles['label']}>Bank Account Number</div>
          <input
            name={'bankAccountNo'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
        </div>
        <div className={styles['bank-routing-number']}>
          <div className={styles['label']}>Bank Routing Number</div>
          <input
            name={'bankRoute'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
        </div>
        <div className={styles['address']}>
          <div className={styles['label']}>Address</div>
          <textarea
            name={'address'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
        </div>
      </div>
      <div className={styles['footer']}>
        <ActionButton
          text={'Cancel'}
          active={!loading}
          isLoading={false}
          onClick={() => props.history.goBack()}
          customClass={styles['cancel']}
        />
        <ActionButton
          text={'Create Account'}
          active={!loading}
          isLoading={loading}
          onClick={createAccountFn}
        />
      </div>
    </div>
  );
};

export { CreateAccount };
